import { useState, Fragment, useEffect, forwardRef } from 'react'
import AddressFormComponent from '../../elements/address-lookup'

const AddressInput = forwardRef(
  ({ lookup, label, name, onChange = () => {}, error, formVariant }, ref) => {
    const [address, setAddress] = useState({})

    const handleAddressChange = (key, addrs) => {
      setAddress(addrs)
    }

    useEffect(() => {
      onChange(address)
    }, [address])

    return (
      <Fragment>
        <input
          type='hidden'
          id='addressInput'
          name={name}
          ref={ref}
          value={JSON.stringify(address)}
        />
        <AddressFormComponent
          label={label}
          lookup={lookup}
          onChange={handleAddressChange}
          error={error}
          formVariant={formVariant}
          hasTimeAtAddress={false}
        />
      </Fragment>
    )
  },
)

export default AddressInput
